import { useAppSelector } from "@/data/hooks";
import { selectHasAutoSubmission } from "@/features/assignment";

import { selectRecordingStartCutoffDatePassed } from "../socratic-slice";

/**
 * Shared recording-eligibility state used by the start / re-attempt controls.
 *
 * `wouldAutoSubmitDuringRecording` is true when auto-submission is enabled and
 * the recording-start cutoff has already passed — i.e. any recording started
 * now would be auto-submitted mid-recording, so starting should be blocked.
 */
export function useRecordingGate() {
  const hasAutoSubmission = useAppSelector(selectHasAutoSubmission);
  const recordingStartCutoffDatePassed = useAppSelector(
    selectRecordingStartCutoffDatePassed
  );

  const wouldAutoSubmitDuringRecording =
    hasAutoSubmission && recordingStartCutoffDatePassed === true;

  return { hasAutoSubmission, wouldAutoSubmitDuringRecording };
}
